import ESAPI from 'node-esapi';

export const sanitizeUserInputForUrl = (userInput: string) => {
  return ESAPI.encoder().encodeForURL(userInput);
};
